import { ReactElement } from "react"

import CreateEVACDeviceForm from "../../../../components/devices/lct/evac/createEVACDeviceForm"
import ContinueEVACDeviceVersionProvider from "../../../../components/devices/lct/evac/providers/continueEVACDeviceVersionProvider"

const ContinueEVACDraftDeviceVersion = (): ReactElement => (
    <ContinueEVACDeviceVersionProvider>
        <CreateEVACDeviceForm />
    </ContinueEVACDeviceVersionProvider>
)

export default ContinueEVACDraftDeviceVersion
